import { Collapse, Grid, Container, Paper } from "@material-ui/core";
import { Loader } from "rsuite";

export default function Loading({ value }) {
  return (
    <Grid item xs={12}>
      <Collapse in={value} unmountOnExit>
          <Loader backdrop vertical speed="slow" content="Carregando" />
      </Collapse>
    </Grid>
  );
}
